<template>
    <Account
            class="v-request-new-password c-account--requestnewpassword"
            :image-header1="$ucfirst($t('login.reset.forgot'))"
            :image-header2="$ucfirst($t('login.reset.recover'))"
            :image-url="$asset('image/reset-password-stock.jpg')"
            :image-aspect-ratio="1054/728"
            :break-after-logo="true"
            :versionInfo='$app.version'
    >
        <h1 v-show="$vuetify.breakpoint.mdAndUp"
            class="v-request-new-password__choosenew text-h5 text-center font-family-futura">
            {{ $ucfirst($t('login.reset.recovery')) }}
        </h1>

        <v-form v-on:submit.prevent="requestNewPassword">
            <div v-if="passwordRequested">
                <p>Thank you, a link has been sent to your e-mail address where you will be able to choose a new password.</p>

                <p class="v-request-new-password__backtologin">
                    <router-link class="inline-stretch text-center secondary--text text-decoration-underline" to="/login">{{
                        $ucfirst($t('login.backtologin')) }}
                    </router-link>
                </p>
            </div>
            <div v-else>
<!--                <v-text-field-->
<!--                        v-model="centerToken"-->
<!--                        :label="$capitalize($t('login.centertoken'))"-->
<!--                        autocomplete="on"-->
<!--                        outlined-->
<!--                ></v-text-field>-->
                <v-text-field
                        v-model="username"
                        :label="$capitalize($t('login.username'))"
                        autocomplete="on"
                        outlined
                ></v-text-field>

                <v-btn color="primary" type="submit" x-large block>
                    {{ $capitalize($t('login.reset.sendemail')) }}
                </v-btn>

                <p class="v-request-new-password__backtologin">
                    <router-link class="inline-stretch text-center secondary--text text-decoration-underline" to="/login">{{
                        $ucfirst($t('login.backtologin')) }}
                    </router-link>
                </p>
            </div>
        </v-form>
    </Account>
</template>

<script>
import Account from "../../components/Account/Account";

/**
 * Component RequestNewPassword.vue
 *
 * @module RequestNewPassword
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/Account/RequestNewPassword.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'RequestNewPassword',
  components: {
    Account
  },
  methods: {
    requestNewPassword: function () {
      this.$app.authentication.requestPasswordReset(
        this.centerToken,
        this.username,
      ).then((data) => {
        this.passwordRequested = true
        this.$toasted.show('Request Processed')
      })
    },
  },
  data: () => ({
    centerToken: '',
    username: '',
    passwordRequested: false
  }),
}
</script>

<style lang="scss">
    // mobile first
    .v-request-new-password__choosenew {
        margin: 50px 0 76px 0;
    }

    .v-request-new-password__backtologin {
        margin-top: 20px;
    }

    .v-application.lg-up{
        .v-request-new-password__backtologin {
            margin-bottom: 81px;
        }
    }
</style>